import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import Bell from '../../../assets/icons/bell';
import Download from '../../../assets/icons/download';
import Add from '../../../assets/icons/add';
import * as css from './SubscriptionActions.css';
import setGlobalState from '../../../redux/setGlobalState';

function SubscriptionActions() {
    const {t} = useTranslation('subscriptions');

    return (
        <css.actions> 
            <Button onClick={() => {}} variant="neutral" size="category" iconStart={<Bell />} disabled>{t('sendAlerts')}</Button>
            <Button onClick={() => {}} variant="neutral" size="category" iconStart={<Download />} disabled>{t('detailedReport')}</Button>
            <css.separator />
            <Button onClick={() => {setGlobalState('ui.show.isOpenCreateSubscription', true);}} variant="brand" size="category" iconStart={<Add />}>{t('newSeries')}</Button>
        </css.actions>
    );
}

export default SubscriptionActions;

